import { Col, Row, Space } from 'antd';
import styled from 'styled-components';
import { CieLoginButton } from './cie/CieLoginButton';
import { CnsLoginButton } from './cns/CnsLoginButton';
import { EidasLoginButton } from './eidas/EidasLoginButton';
import { ProfessionalSpidLoginButton } from './spid/ProfessionalSpidLoginButton';
import { SpidInfoPopover } from './spid/SpidInfoPopover';
import { SpidLoginButton } from './spid/SpidLoginButton';

export {
  CieLoginButton,
  CnsLoginButton,
  EidasLoginButton,
  SpidInfoPopover,
  SpidLoginButton,
  ProfessionalSpidLoginButton,
};

const LoginButtonRow = styled(Row)`
  padding-top: 12px;
  /* flex-direction: column; */
  flex-direction: row;
  justify-content: center;
  /* @include respond-to('lg', 'min') {
    flex-direction: row;
  } */
`;

const LoginButtonColumn = styled(Col)`
  width: 270px;
  padding-left: 20px;
  padding-top: 12px;
  /* @include respond-to('xs', 'max') {
    width: 248px;
    padding-left: 6px;
  } */
`;

export interface OpenWebLoginButtonsProps {
  resolvePublicUrl: (path: string) => string;
}

/**
 * Login di un utente con SPID - CIE - EIDAS
 */
export function OpenWebLoginButtons(props: OpenWebLoginButtonsProps) {
  const { resolvePublicUrl } = props;
  return (
    <Row justify="center">
      <Col>
        <LoginButtonRow>
          <LoginButtonColumn>
            <Space direction="horizontal" size={5} align="start">
              <SpidLoginButton resolvePublicUrl={resolvePublicUrl} />
              <SpidInfoPopover />
            </Space>
          </LoginButtonColumn>
          <LoginButtonColumn>
            <CieLoginButton resolvePublicUrl={resolvePublicUrl} />
          </LoginButtonColumn>
          <LoginButtonColumn>
            <EidasLoginButton resolvePublicUrl={resolvePublicUrl} />
          </LoginButtonColumn>
        </LoginButtonRow>
      </Col>
    </Row>
  );
}
